import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, UserPlus, ArrowRight, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { api, formatDateBR } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function NovosClientes() {
  const [contracts, setContracts] = useState(null);

  useEffect(() => {
    api.get("/contracts").then(({ data }) => setContracts(data));
  }, []);

  if (!contracts) return <Skeleton className="h-96" />;

  const novos = contracts.filter(
    (c) => c.status === "pending_assignment" || (!c.consultant_id && !c.providencia_status),
  );

  return (
    <div className="space-y-6" data-testid="novos-clientes-page">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 flex items-center gap-2">
          <UserPlus className="w-6 h-6 text-midnight" /> Novos Clientes
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Contratos cadastrados pelo Comercial que aguardam andamento da Secretária
          (registrar providências, agendar reunião inaugural, etc.).
        </p>
        <div className="mt-3 p-3 border border-amber-200 bg-amber-50 rounded-md text-xs text-amber-900 max-w-2xl">
          <strong>Importante:</strong> a designação do consultor responsável é feita
          exclusivamente pela Diretora — você não verá esse botão aqui.
        </div>
      </div>

      <Card className="card-soft">
        <CardHeader>
          <CardTitle className="text-base">
            Contratos aguardando andamento ({novos.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          {novos.length === 0 ? (
            <div className="text-sm text-slate-500 py-8 text-center">
              Nenhum cliente novo aguardando.
            </div>
          ) : (
            <div className="space-y-3">
              {novos.map((c) => (
                <Link
                  key={c.id}
                  to={`/secretaria/contratos/${c.id}`}
                  className="block p-4 border border-slate-200 rounded-lg hover:border-midnight/50 hover:bg-slate-50 transition-colors"
                  data-testid={`novo-cliente-${c.id}`}
                >
                  <div className="flex items-start justify-between gap-3 flex-wrap">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <Building2 className="w-4 h-4 text-slate-500" />
                        <span className="font-medium text-slate-900">{c.client_name}</span>
                        <Badge variant="outline" className="text-[10px] border-amber-300 text-amber-700">
                          <Clock className="w-3 h-3 mr-1" /> Aguardando andamento
                        </Badge>
                      </div>
                      <div className="text-xs text-slate-500 mt-1">
                        Produto: {c.product_name}
                      </div>
                      <div className="text-xs text-slate-500">
                        Início: {formatDateBR(c.start_date)} · Término: {formatDateBR(c.end_date)}
                      </div>
                    </div>
                    <ArrowRight className="w-4 h-4 text-slate-400 mt-1" />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
